export const usaStates = [
    {
        label: '',
        value: '',
        hasStore: 'false',
    },
    {
        label: 'Alabama',
        value: 'AL',
        hasStore: true,
    },
    {
        label: 'Alaska',
        value: 'AK',
        hasStore: false,
    },
    {
        label: 'Arizona',
        value: 'AZ',
        hasStore: true,
    },
    {
        label: 'Arkansas',
        value: 'AR',
        hasStore: false,
    },
    {
        label: 'California',
        value: 'CA',
        hasStore: true,
    },
    {
        label: 'Colorado',
        value: 'CO',
        hasStore: true,
    },
    {
        label: 'Connecticut',
        value: 'CT',
        hasStore: true,
    },
    {
        label: 'Delaware',
        value: 'DE',
        hasStore: true,
    },
    {
        label: 'D.C.',
        value: 'DC',
        hasStore: false,
    },
    {
        label: 'Florida',
        value: 'FL',
        hasStore: true,
    },
    {
        label: 'Georgia',
        value: 'GA',
        hasStore: true,
    },
    {
        label: 'Hawaii',
        value: 'HI',
        hasStore: false,
    },
    {
        label: 'Idaho',
        value: 'ID',
        hasStore: true,
    },
    {
        label: 'Illinois',
        value: 'IL',
        hasStore: true,
    },
    {
        label: 'Indiana',
        value: 'IN',
        hasStore: true,
    },
    {
        label: 'Iowa',
        value: 'IA',
        hasStore: true,
    },
    {
        label: 'Kansas',
        value: 'KS',
        hasStore: true,
    },
    {
        label: 'Kentucky',
        value: 'KY',
        hasStore: true,
    },
    {
        label: 'Louisiana',
        value: 'LA',
        hasStore: true,
    },
    {
        label: 'Maine',
        value: 'ME',
        hasStore: true,
    },
    {
        label: 'Maryland',
        value: 'MD',
        hasStore: true,
    },
    {
        label: 'Massachusetts',
        value: 'MA',
        hasStore: true,
    },
    {
        label: 'Michigan',
        value: 'MI',
        hasStore: true,
    },
    {
        label: 'Minnesota',
        value: 'MN',
        hasStore: true,
    },
    {
        label: 'Mississippi',
        value: 'MS',
        hasStore: true,
    },
    {
        label: 'Missouri',
        value: 'MO',
        hasStore: true,
    },
    {
        label: 'Montana',
        value: 'MT',
        hasStore: false,
    },
    {
        label: 'Nebraska',
        value: 'NE',
        hasStore: true,
    },
    {
        label: 'Nevada',
        value: 'NV',
        hasStore: true,
    },
    {
        label: 'New Hampshire',
        value: 'NH',
        hasStore: true,
    },
    {
        label: 'New Jersey',
        value: 'NJ',
        hasStore: true,
    },
    {
        label: 'New Mexico',
        value: 'NM',
        hasStore: true,
    },
    {
        label: 'New York',
        value: 'NY',
        hasStore: true,
    },
    {
        label: 'North Carolina',
        value: 'NC',
        hasStore: true,
    },
    {
        label: 'North Dakota',
        value: 'ND',
        hasStore: false,
    },
    {
        label: 'Ohio',
        value: 'OH',
        hasStore: true,
    },
    {
        label: 'Oklahoma',
        value: 'OK',
        hasStore: true,
    },
    {
        label: 'Oregon',
        value: 'OR',
        hasStore: true,
    },
    {
        label: 'Pennsylvania',
        value: 'PA',
        hasStore: true,
    },
    {
        label: 'Rhode Island',
        value: 'RI',
        hasStore: true,
    },
    {
        label: 'South Carolina',
        value: 'SC',
        hasStore: true,
    },
    {
        label: 'South Dakota',
        value: 'SD',
        hasStore: false,
    },
    {
        label: 'Tennessee',
        value: 'TN',
        hasStore: true,
    },
    {
        label: 'Texas',
        value: 'TX',
        hasStore: true,
    },
    {
        label: 'Utah',
        value: 'UT',
        hasStore: true,
    },
    {
        label: 'Vermont',
        value: 'VT',
        hasStore: false,
    },
    {
        label: 'Virginia',
        value: 'VA',
        hasStore: true,
    },
    {
        label: 'Washington',
        value: 'WA',
        hasStore: true,
    },
    {
        label: 'West Virginia',
        value: 'WV',
        hasStore: false,
    },
    {
        label: 'Wisconsin',
        value: 'WI',
        hasStore: true,
    },
    {
        label: 'Wyoming',
        value: 'WY',
        hasStore: false,
    },
];
